import { Box, Heading, HStack, Stack, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { AiOutlineMail } from "react-icons/ai";
import { ImMobile } from "react-icons/im";
import { MdWebAsset } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Footer } from "../components/Footer/Footer";
import { Navigation } from "../components/header/Navigation";
import { useContaxt } from "../context/Context";

export function Imprint() {
  const { color } = useContaxt();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>WebWerk am Meer | Impressum | Webdesign aus Kiel</title>
        <meta
          name="title"
          content="WebWerk am Meer | Impressum | Webdesign aus Kiel"
        />
        <meta
          name="description"
          content="Webwerk am Meer ist eine Webdesign Agentur aus Kiel. Wir als Unternehmen streben nach Verbesserung für unsere Kunden im Bereich Webdesign & Webentwicklung."
        />

        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://webwerk-am-meer.de/impressum/"
        />
        <meta
          property="og:title"
          content="WebWerk am Meer | Impressum | Webdesign aus Kiel"
        />
        <meta
          property="og:description"
          content="Webwerk am Meer ist eine Webdesign Agentur aus Kiel. Wir als Unternehmen streben nach Verbesserung für unsere Kunden im Bereich Webdesign & Webentwicklung."
        />
        <meta
          property="og:image"
          content="https://webwerk-am-meer.de/data/webwerk_meta_preview.jpg"
        />

        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://webwerk-am-meer.de/impressum/"
        />
        <meta
          property="twitter:title"
          content="WebWerk am Meer | Impressum | Webdesign aus Kiel"
        />
        <meta
          property="twitter:description"
          content="Webwerk am Meer ist eine Webdesign Agentur aus Kiel. Wir als Unternehmen streben nach Verbesserung für unsere Kunden im Bereich Webdesign & Webentwicklung."
        />
        <meta
          property="twitter:image"
          content="https://webwerk-am-meer.de/data/webwerk_meta_preview.jpg"
        />
      </Helmet>
      <Navigation />
      <Stack
        as="main"
        role="main"
        px={[5, 5, 5, 10]}
        py={[10, 15, 20, 20]}
        mt={10}
        fontWeight={"bold"}
        fontSize={20}
        textAlign="left"
      >
        <Heading as="h1" fontSize={35}>
          IMPRESSUM
        </Heading>
        <Box h={1} w={120} bgColor={color.mainColor} />
        <Text fontWeight={"extrabold"}>WebWerk am Meer | Webdesign Kiel</Text>
        <Text>
          Dubenhorst 9
          <br />
          24114 Kiel
        </Text>
        <br />
        <HStack
          _hover={{ color: color.mainColor }}
          cursor={"pointer"}
          onClick={() => (window.location = "tel:015758308209")}
        >
          <ImMobile size={25} />
          <Text fontSize={20}>+49 157 583 082 09</Text>
        </HStack>
        <HStack
          _hover={{ color: color.mainColor }}
          cursor={"pointer"}
          onClick={() =>
            (window.location =
              "mailto:kontakt@webwerk-am-meer.de?subject=Kontaktanfrage")
          }
        >
          <AiOutlineMail size={25} />
          <Text>kontakt@webwerk-am-meer.de</Text>
        </HStack>
        <br />
        <Text>
          Geschäftsführer:
          <br />
          Lukas Körber
        </Text>
        <br />
        <Text>
          Amtsgericht Kiel - HRB 26702 KI
          <br />
          Steuer-Nr. - 20/296/60051 Finanzamt Kiel
          <br />
          USt - IdNr.: DE367666545
        </Text>
        <br />
        <br />
        <Text fontSize={[25, 25, 30, 35]}>HAFTUNGSHINWEIS</Text>
        <Box h={1} w={200} bgColor={color.mainColor} />
        <br />
        <Text>
          Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung
          für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten
          sind ausschließlich deren Betreiber verantwortlich.
        </Text>
        <br />
        <br />
        <Text fontSize={[20, 25, 30, 35]}>
          GESTALTUNG, KONZEPTION, TECHNISCHE UMSETZUNG
        </Text>
        <Box h={1} w={650} maxWidth={"70vw"} bgColor={color.mainColor} />
        <br />
        <Text>
          WebWerk am Meer <br />
          Werbe- und Marketingagentur
          <br />
          <br />
          <HStack
            cursor="pointer"
            onClick={() => (window.location = "https://webwerk-am-meer.de/")}
          >
            <MdWebAsset size={40} />
            <a>www.webwerk-am-meer.de</a>
          </HStack>
        </Text>
      </Stack>
      <Footer />
    </>
  );
}
